import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.service-slider__splide' ).length ) {
        const sliders = {};
        $( '.service-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '20px',
            perPage: 3,
            focus: 'center',
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );

          const splideNav = slider.root.querySelector( '.service-slider__splide-nav' );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
              focus: 0,
            };
            if ( !isOverflow ) {
              splideNav.style.display = 'none';
            } else {
              splideNav.style.display = 'flex';
            }
          } );

          slider.mount();

          const tabId = $( this ).attr( 'data-tab-id' );
          sliders[tabId] = slider;
        } );

        $( '.featured-services-tabs' ).each( function() {
          const component = $( this );
          const form = component.find( '.js-featured-services-tabs__form' );
          let currentSlider = component.find( '.featured-services-tabs__tab-content.is-open' ).attr( 'id' );

          form.on( 'change', function( event ) {
            event.preventDefault();
            const changedField = $( event.target );
            const updatedSlider = changedField.val();

            if ( !updatedSlider || updatedSlider === currentSlider ) return;

            /* Show the slider and update aria attribute */
            component.find( `#${currentSlider}` ).removeClass( 'is-open' ).attr( 'aria-hidden', true );
            component.find( `#${updatedSlider}` ).addClass( 'is-open' ).attr( 'aria-hidden', false );

            currentSlider = updatedSlider;

            /* refresh selected slider so the Splide arrows are displayed */
            if ( sliders[currentSlider] ) sliders[currentSlider].refresh();

            /* make sure form fields have same value */
            const select = form.find( '.featured-services-tabs__select' );
            if ( changedField.is( 'select' ) ) {
              form.find( `.featured-services__radio-input[value="${currentSlider}"]` ).prop( 'checked', true );
            } else {
              select.val( currentSlider );
            }

            const announcement = component.find( '.featured-services-tabs__announcement' );
            /* announce the slider has been displayed */
            const selectedTitle = $( `#${select.attr( 'id' )} option:selected` ).text();
            announcement.text( `${selectedTitle} slider is displayed` );

            return false;
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
